/**
 * Determines the backend API URL based on environment:
 * - Production: Uses relative path '/api'
 * - Development: Uses full URL with localhost
 * 
 * @constant {string}
 */
const BACKEND_API_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:4000/api';

export default BACKEND_API_URL;

export const handleRegister = async (username, password, email, registrationData) => {
    try {
      const response = await fetch(`${BACKEND_API_URL}/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          username, 
          password, 
          email, 
          company: registrationData?.company 
        }),
      });
      
      const result = await response.json();
      
      return {
        success: response.ok,
        message: result.message || (response.ok ? 'Registration successful' : 'Registration failed')
      };

    } catch (error) {
      return {
        success: false,
        message: 'Failed to register. Please try again.'
      };
    }
};

export const handleLogin = async (username, password) => {
    try {
      const response = await fetch(`${BACKEND_API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      
      const result = await response.json();
      
      if (result.token) {
        localStorage.setItem('authToken', result.token);
        localStorage.setItem('username', username);
        return {
          success: true,
          message: 'Login successful!'
        };
      }
      
      return {
        success: false,
        message: result.message || 'Login failed'
      };

    } catch (error) {
      return {
        success: false,
        message: 'Failed to login. Please try again.'
      };
    }
};

export const checkAuthToken = async () => {
    const token = localStorage.getItem('authToken');
    const username = localStorage.getItem('username');
    
    if (!token) {
      return false;
    }
  
    try {
      const response = await fetch(`${BACKEND_API_URL}/isAuthorized`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
  
      if (response.status === 401) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('username');
        return false;
      }
  
      await response.json();
      return response.ok;
  
    } catch (error) {
      return false;
    }
};

export const logoutUser = () => {
  try {
    // Clear auth token and username
    localStorage.removeItem('authToken');
    localStorage.removeItem('username');
    
    return { success: true, message: 'Logged out successfully' };
  } catch (error) {
    return { success: false, message: 'Error during logout' };
  }
};

export const loginUser = (username, password) => {
  return new Promise((resolve, reject) => {
    // Your existing auth code here
    setTimeout(() => {
      if (username && password) {
        // Mock successful login
        localStorage.setItem('authToken', 'mock-jwt-token');
        localStorage.setItem('username', username);
        
        resolve({ success: true, message: 'Login successful' });
      } else {
        reject({ success: false, message: 'Invalid credentials' });
      }
    }, 1000);
  });
};

export const registerUser = (username, email, password) => {
  return new Promise((resolve, reject) => {
    // Your existing register code here
    setTimeout(() => {
      if (username && email && password) {
        // Mock successful registration
        localStorage.setItem('authToken', 'mock-jwt-token');
        localStorage.setItem('username', username);
        
        resolve({ success: true, message: 'Registration successful' });
      } else {
        reject({ success: false, message: 'Please fill all fields' });
      }
    }, 1000);
  });
};